import { Button, Card } from "react-bootstrap"
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
 

const Co_Hosts = () => {
const navigate =useNavigate()
  const co_Hosts = [
    {
      id: 1,
      name: "abc",
      phone: 2132323312321,
    },
    {
      id: 2,
      name: "xyz",
      phone: 2132323312321,
    },
    {
      id: 3,
      name: "uvw",
      phone: 2132323312321,
    },
    {
      id: 4,
      name: "sdf",
      phone: 2132323312321,
    },
  ];
    const location = useLocation();
    const historyData = location.state?.history;
 
  return (
    <div>
       <PageTitle
          motherMenu="User List"
          activeMenu={`   ${historyData?.user?.hostName} > Co-Hosts`}
          pathBack={true}   
        />
  <h2 className=" mb-4 user-detail-title font-fm" style={{ fontSize: "50px" }}>
   
      </h2>
      <Card className="shadow-lg   cohost-card mb-5 rounded-3">
        <Card.Body>
          {co_Hosts.map((host) => (
            <div
              key={host.id}
              className="cohost-item mb-3 p-3 rounded d-flex justify-content-between align-items-center"
              style={{ border: "1px solid #eee", background: "#fafafa" }}
            >
              {/* Left side - Co-host details */}
              <div>
                <h5 className="fw-bold mb-2">{host.name}</h5>
                <p className="mb-0 " style={{color:"maroon"}}>📞 {host.phone}</p>
              </div>

              {/* Right side - Event button */}
              <Button
                className="maroon-btn"
                onClick={() => navigate(`/co-host/${host.id}`)}
              >
                View Profile
              </Button>
            </div>
          ))}
 
      
        </Card.Body>
      </Card>


    </div>
  )
}

export default Co_Hosts
